import React from 'react';
import { MuiTelInput } from 'mui-tel-input';
import CloseIcon from '@mui/icons-material/Close';

// utils
import { useConfig } from '@rs-core/context/ConfigContext';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { getEntityCountryCode } from '@rs-core/utils/healthCardNumberValidator';

const PhoneInput = ({ options, onChange, formField, variant, className, item, index  }) => {
    
	const [value, setValue] = React.useState(item?.value.startsWith('+') ? item?.value : `+${item?.value}`);
	const handleChange = (newValue, idx) => {
	  setValue(newValue);
		// eslint-disable-next-line no-param-reassign
		options[idx].value = newValue;
	};
		
	const __config = useConfig();
	const defaultCountry = getEntityCountryCode(__config.resource_group);

    return (
        <MuiTelInput
        fullWidth
        InputProps={{
            endAdornment: !formField?.disabled && (
                <InputAdornment position="end">
                    <IconButton
                        edge="end"
                        onClick={() => {
                            onChange(null, null, `${formField?.mapping}.${index}`, true);
                        }}
                    >
                        <CloseIcon data-cy={`form-field-${formField?.name}-clear`} />
                    </IconButton>
                </InputAdornment>
            ),
            'data-testid': 'phone-text-field',
        }}
        className={className}
        data-testid="form-field"
        defaultCountry={defaultCountry}
        id={formField.id ? `${formField.id}-${index}` : formField?.disabled?`form-field-${formField.name}-${index}`:`form-field-${formField.name}`}
        required={formField?.required}
        value ={value}
        variant={variant || 'outlined'}
        onChange={(event)=>handleChange(event, index)}
        disabled={formField?.disabled}
    />
    );
};

export default PhoneInput;